<template>
  <div class="page-header-container --fixed" id="fullPageHeader" ref="header" v-if="!isDetailOn">
    <div class="header-main-container">
      <router-link
        class="header-logo"
        :to="{
          path: '/'
        }"
      >
        <img src="@/assets/images/logo.png" alt="" />
      </router-link>
      <div
        class="header-menu-icon"
        @click="onClickMenuIcon"
        :class="{
          actived: menuSwitch
        }"
        v-if="isShowMenu"
      >
        <template v-if="false">
          <div
            class="mobile-header-nav-container"
            :class="{
              '-white-line': $route.name === 'home'
            }"
          >
            <div class="nav__lines-container">
              <i class="line__item"></i>
              <i class="line__item"></i>
              <i class="line__item"></i>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="menu__text">
            <p>close</p>
          </div>
          <div
            class="menu__icon"
            :class="{
              '-white-line': $route.name === 'home'
            }"
          >
            <span class="line-top"></span><span class="line-bottom"></span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'page-header',
  props: {
    isShowMenu: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isDetailOn: false,
    };
  },
  computed: {
    ...mapState({
      menuSwitch: 'd1MenuSwitch',
      isMobileAboutDetailShow: 'mobileAboutDetailOnShow',
    }),
  },
  watch: {
    $route: {
      handler() {
        this.headerInit();
      },
      immediate: true,
    },
    isDetailOn(val) {
      console.log(val);
    },
  },
  mounted() {
    this.$root.$on('detailOn', () => {
      this.isDetailOn = true;
    });
    this.$root.$on('detailOff', () => {
      this.isDetailOn = false;
    });
  },
  methods: {
    ...mapMutations(['OPEN_MENU', 'CLOSE_MENU']),
    onClickMenuIcon() {
      if (this.menuSwitch) {
        this.CLOSE_MENU();
      } else {
        this.OPEN_MENU();
      }
    },
    headerInit() {
      const that = this;
      that.$nextTick(() => {
        that.$refs.header.classList.remove('fixed-donw-show');
      });
    },
  },
};
</script>

<style></style>
